import { HttpEvent, HttpInterceptorFn, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, filter, tap } from 'rxjs';

import { AuthService } from '../../auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  
  return next(req).pipe(
    filter(event => event instanceof HttpResponse),
    tap((httpEvent) => {

      // Checks if the HttpEvent is a successful (200 OK) HttpResponse, but has an invalid response body format.
      if(checkInvalid200Response(httpEvent)){
        authService.remove('token')
        const error = new Error('An internal error has occurred. Please try again later.')
      
        throw error
      }
    }),
    catchError(error => {
      if(error.error.error_code === 21003) {
        authService.remove('token')
        router.navigate(['/login'])
      } else if(error.error.code === "404") {
        router.navigate(['404'])
      }
      throw error
    })
  )
};

/**
 * Helper function to check if an HttpEvent is a successful 200 OK response, but with an unexpected body format.
 * @param httpEvent The HttpEvent to be checked.
 * @returns True if it's a 200 OK HttpResponse that fails the body format check, false otherwise.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function checkInvalid200Response(httpEvent: HttpEvent<any>): boolean {
  return (
    // Must be an instance of HttpResponse (i.e., a response, not a request or other event)
    httpEvent instanceof HttpResponse
    // Must have a successful status code (200 OK)
    && httpEvent.status === HttpStatusCode.Ok
    // But the body format must be invalid
    && check200ResponseBodyFormat!(httpEvent)
  )
}

/**
 * Verifies if the response body adheres to the expected format for a successful (200 OK) response.
 * The expected format is a plain object with a 'status' property of 'ok' and a defined 'data' property.
 * @param response The HttpResponse to check.
 * @returns True if the response body matches the expected format, false otherwise.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function check200ResponseBodyFormat(response: HttpResponse<any>): boolean {
  if(!response.body) return false
  return typeof response.body === 'object'
    && response.body.statusText === 'OK'
    && response.body.name === "HttpErrorResponse"
    //&& response.body.data !== undefined
}
